//namespace Pacem.Net {
export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Get"] = "GET";
    HttpMethod["Post"] = "POST";
    HttpMethod["Put"] = "PUT";
    HttpMethod["Delete"] = "DELETE";
    HttpMethod["Options"] = "OPTIONS";
    HttpMethod["Head"] = "HEAD";
    HttpMethod["Patch"] = "PATCH";
    HttpMethod["Connect"] = "CONNECT";
    HttpMethod["Trace"] = "TRACE";
})(HttpMethod || (HttpMethod = {}));
export const FetchResultEventName = 'fetchresult';
export const FetchErrorEventName = 'error';
export const FetchSuccessEventName = 'success';
export class Fetcher {
    static isEmpty(r) {
        return r.status === 204 || r.headers.get("Content-Length") === "0";
    }
}
//}
